import type { IAppointmentBranch, IAppointmentSettings, ITopic } from '../../api/domain';
import type { IRootState } from '../root-reducer';

export const getBranches = (state: IRootState): IAppointmentBranch[] | undefined => state?.appointmentsApi?.branches;
export const getTopics = (state: IRootState): ITopic[] => state?.appointmentsApi?.topics || [];
export const getSettings = (state: IRootState): IAppointmentSettings => state?.appointmentsApi?.settings;
export const getTimeslots = (state: IRootState) => state?.appointmentsApi?.timeslots;
export const getRmTimeslots = (state: IRootState) => state?.appointmentsApi?.rmTimeslots;
export const getBookedAppointment = (state: IRootState) => state?.appointmentsApi?.bookedAppointment;
export const getBookedAnonymousAppointmentAppointment = (state: IRootState) => state.appointmentsApi?.bookedAnonymousAppointment;
export const getSelectedCustomerBaseForAppointment = (state: IRootState) => state.appointmentsApi?.selectedCustomerBaseForAppointment;
